// src/components/TeamSection.jsx
import React from 'react';
import nathalieImage from '../assets/images/team/nathalieandre.jpeg';
import AliceImage from '../assets/images/team/team-01/image-01.jpg';
import MarcImage from '../assets/images/team/team-01/image-03.jpg';

const teamMembers = [
  {
    name: 'Nathalie Andre',
    role: 'Executive adivsor',
    image: nathalieImage,
    linkedin: 'https://www.linkedin.com/in/nathalie-andre-innovation/',
  },
  {
    name: 'Alice Morel',
    role: 'Consultante stratégie digitale',
    image: AliceImage,
    linkedin: '#',
  },
  {
    name: 'Marc Dubois',
    role: 'Consultant en transformation B2B',
    image: MarcImage,
    linkedin: '#',
  },
];

const TeamSection = () => {
  return (
    <section className="bg-slate-50 py-20">
      <div className="container mx-auto px-4">
        {/* Intro */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <span className="text-sm font-medium text-gray-500 uppercase tracking-wider">
            NOTRE ÉQUIPE
          </span>
          <h2 className="text-4xl font-bold text-gray-800 mt-2 mb-4">
            Des experts réunis pour votre réussite
          </h2>
          <p className="text-gray-600">
            Chez AmplifyMyCom, notre force naît de la complémentarité : experts en IA,
            stratégie digitale et communication travaillent ensemble pour propulser votre
            impact sur LinkedIn. Parce qu’ensemble, nous allons plus loin.
          </p>
        </div>

        {/* Cards */}
        <div className="flex flex-wrap justify-center gap-10">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="w-full max-w-xs bg-white shadow-md rounded-xl overflow-hidden p-6 text-center"
            >
              {member.image ? (
                <img
                  src={member.image}
                  className="mx-auto mb-4 h-32 w-32 rounded-full object-cover shadow"
                  alt={member.name}
                />
              ) : (
                <div className="mx-auto mb-4 h-32 w-32 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-sm">
                  Photo
                </div>
              )}
              <h3 className="text-xl font-semibold text-gray-900">{member.name}</h3>
              <p className="text-sm text-gray-500 mb-3">{member.role}</p>
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 text-sm font-medium"
              >
                Voir sur LinkedIn →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
